import { IMenuAccess, IMenuDefinition } from "interfaces";
import strings from "strings";
import { isClaimsOnly } from "tools/auth";

// Single source of menu truth: dropping an entry here hides it from the sidebar AND makes
// ProtectedRoute 404 direct URL navigation to it, so a role restriction needs no per-component work.
// CLAIMS_ONLY keeps Events Feed, Profile and Help. Profile stays deliberately (plan §6.1) so the
// user can rotate their own password; to revoke it, flip that entry to !isClaimsOnly() and drop the
// two password endpoints from the user-management-api allow-list.
const menus: IMenuDefinition[] = [
  { name: strings.MENU.DASHBOARD,   url: strings.ROUTES.DASHBOARD,   canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.CARRIERS,    url: strings.ROUTES.CARRIERS,    canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.REPORTING,   url: strings.ROUTES.REPORTING,   canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.EVENTS_FEED, url: strings.ROUTES.EVENTS_FEED, canViewMenu: () => true },
  { name: strings.MENU.FLEET_MONITORING, url: strings.ROUTES.FLEET_MONITORING, canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.FLEETFILE,    url: strings.ROUTES.FLEETFILE,    canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.SETTINGS,    url: strings.ROUTES.SETTINGS,    canViewMenu: () => !isClaimsOnly() },
  { name: strings.MENU.PROFILE,     url: strings.ROUTES.PROFILE,     canViewMenu: () => true },
]

const getInsuranceMenuAccess = (): IMenuAccess[] => {
  const menuList: IMenuAccess[] = menus
    .filter(menu => menu.canViewMenu())
    .map(({ name, url }) => ({ name, url }))

  menuList.push({ name: strings.MENU.HELP })

  return menuList
}

export default getInsuranceMenuAccess
